import React, { useRef, useState } from 'react'
import KeyboardReact from 'react-simple-keyboard'
import './VirtualKeyBoard.css'
import { connect } from 'react-redux';
import { keyboardPlanTools, numericLocker } from './Utilities';
import Draggable from "react-draggable";
import { useTranslation } from 'react-i18next'


const VirtualKeyboardChild = (props)=>{
    const {t} = useTranslation(['customize-order'])
    const [activeId,setActiveId] = useState("")
    const [layoutName,setLayoutName] = useState("default")
    const [planTools,setPlanTools] = useState(keyboardPlanTools)
    const [className,setClassName] = useState('plantools')
    const keyBoardRefNew = useRef(null)

    window.addEventListener("focusin",(e)=>{
        e.preventDefault()
        if(String(e.target.tagName).toLowerCase().includes('input') && (activeId !== e.target.id || (String(e.target.type).includes('password'))) ){
            if(String(e.target.placeholder).toLowerCase().includes('number')){
                setPlanTools(numericLocker)
                setLayoutName('default')
                setClassName("numericLocker")
            }else{
                setPlanTools(keyboardPlanTools)
                setClassName("plantools")
            }
            setActiveId(e.target.id)
            const abc = document.getElementById("scrollTo")
            if(abc){
                abc.style.position = "absolute"
                abc.style.top = document.getElementById(e.target.id).getBoundingClientRect().top + window.scrollY + 60 + "px"
            }
            if(keyBoardRefNew && keyBoardRefNew.current){
                // keyBoardRefNew.current.clearInput()
                keyBoardRefNew.current.setInput(e.target.value)
            }
            const abcd = document.getElementById("anim-kbrd-ctnr")
            if(abcd) abcd.style.display = 'block'
        }else if(!String(e.target.tagName).toLowerCase().includes('input')) setActiveId(undefined)
    })    
    const handleKeyPress = (val)=>{
        switch(val){
            case "{abc}" : setLayoutName("default")
                            break;
            case "{splchars}" : setLayoutName("splchars")
                            break;
            case "{shiftleft}" : setLayoutName(layoutName === "shift" ? "default" : "shift")
                            break;
            case "Clear" : if(keyBoardRefNew && keyBoardRefNew.current) keyBoardRefNew.current.setInput("")
                            break;
             case "{accept}" : setActiveId(undefined)
                            break;
            default : setLayoutName(layoutName)
        }
    }
const loadVirtualKeyborad = t("loadVirutalKeyBoard",{ns:"customize-order"})
if(activeId && loadVirtualKeyborad && typeof loadVirtualKeyborad == "boolean"){
    const selectedElement = document.getElementById(activeId)
return(
    <div id="anim-kbrd-ctnr" >
    <Draggable >
    <div className='react-draggable anim-vir-kbd' id="scrollTo" style={{zIndex:999999}}>
    <div style={{display:'flex',justifyContent:'center'}}>
    <div className={'btn-prnt '+className}>
    <DragButton/>
    <CloseButton onClose={()=>{
        setActiveId(undefined)
    }}/>
    </div>
    </div>
    <KeyboardReact 
    onKeyPress={handleKeyPress}
    {...planTools}
    theme = {"hg-theme-default "+className}
    keyboardRef = {(ref)=>{
        if(keyBoardRefNew)
        return keyBoardRefNew.current = ref
    }}
    layoutName={layoutName}
    onChange={(input)=>{
        if(selectedElement){
            const htmlInputElement = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,'value').set;
            htmlInputElement.call(selectedElement,input)
            const event = new Event('input',{bubbles:true})
            selectedElement.dispatchEvent(event)
        }
    }} 
    />
   </div>
    </Draggable>
    </div>
)
}else return <></>
}

const CloseButton = ({onClose = ()=>{}})=>{
    return(
        <div style={{cursor:'pointer'}} onClick={onClose}  onTouchStart={onClose} className='close'>
            <svg role="img" aria-hidden="false" aria-label="close-alternate icon" viewBox="0 0 21.6 21.6" fill="white" class="StyledSVG-VDS__sc-3zla24-0 YxeRn"><title>close-alternate icon</title><path d="M10.8,1.78a9,9,0,1,0,9,9A9,9,0,0,0,10.8,1.78Zm0,16.88a7.88,7.88,0,1,1,7.88-7.88A7.89,7.89,0,0,1,10.8,18.66ZM14.38,8l-2.79,2.78,2.79,2.79-.8.79L10.8,11.58,8,14.36l-.8-.79L10,10.78,7.22,8,8,7.2,10.8,10,13.58,7.2Z" stroke="none" fill="white"></path></svg>
        </div>
    )
}
const DragButton = ()=>{
    return(
        <div className='drg-btn box cursor' style={{cursor:'pointer'}} >
            <svg role="img" aria-hidden="false" aria-label="drag-handler icon" viewBox="0 0 38 38" fill="white" class="StyledSVG-VDS__sc-3zla24-0 YxeRn"><title>drag-handler icon</title><path d="M16.97361,11.73292H8.25V3h8.72361ZM10.23609,9.74511h4.75144V4.98781H10.23609Zm6.76338,13.62135H8.27586V14.63354h8.72361ZM10.262,21.37865h4.75144v-4.7573H10.262ZM16.97361,35H8.25V26.26708h8.72361Zm-6.73752-1.98781h4.75144v-4.7573H10.23609Zm19.488-21.27927H21.00053V3h8.72361ZM22.98661,9.74511h4.75144V4.98781H22.98661ZM29.75,23.36646H21.02639V14.63354H29.75Zm-6.73753-1.98781h4.75144v-4.7573H23.01247ZM29.72414,35H21.00053V26.26708h8.72361Zm-6.73753-1.98781h4.75144v-4.7573H22.98661Z" stroke="none" fill="white"></path></svg>
        </div>
    )
}
const VirtualKeyboard = (props)=>{
    if(props.fiosreferral && props.fiosreferral === 'Y'){
    return(
        <VirtualKeyboardChild {...props}/>
    )
    }else return <></>
}

export const mapStateToProps = state => ({
    fiosreferral : state.CustomizeOrder.isFiosReferralEnabled,
})
export default connect(mapStateToProps,()=>{})(VirtualKeyboard)